import React from 'react';
import './App.css';
import Roteador from './Component/Roteador';

class App extends React.Component {
  render() {
    return (
      <div>
        <Roteador />
      </div>
    );
  }
}

export default App;
